import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import DesktopMenu from "../components/DesktopMenu"
import Digitizing from "../components/Shared/Digitizing"
import TryDemo from "../components/Home/TryDemo"
import { Media, MediaContextProvider } from "../utils/media"
import ArtistDetail from "../components/Artist/detail"

const ArtistTemplate = ({ data }) => {
  const { artist } = data

  const elements = [
    <DesktopMenu />,
    <ArtistDetail artist={artist} />,
    <Digitizing />,
    <TryDemo />,
  ]

  return (
    <Layout
      title={artist.name}
      description={artist.biography}
      image={artist.medium_image_url}
      style={{ paddingTop: "4em", paddingBottom: "4em" }}
    >
      <MediaContextProvider>
        <Media lessThan={"tablet"}>
          {React.Children.map(elements, child =>
            React.cloneElement(child, { isMobile: true }),
          )}
        </Media>
        <Media greaterThanOrEqual={"tablet"}>
          {React.Children.map(elements, child =>
            React.cloneElement(child, { isMobile: false }),
          )}
        </Media>
      </MediaContextProvider>
    </Layout>
  )
}

export const pageQuery = graphql`
  query ArtistById($_id: String!) {
    artist(_id: { eq: $_id }) {
      _id
      name
      biography
      small_image_url
      medium_image_url
      image_url
      website_url
      birth_year
      birth_date
      nationality
    }
  }
`

export default ArtistTemplate
